import { computed, inject, Injectable } from '@angular/core';

import { TellentCurrentUserDataFacade } from '@core/tellent-logic';
import { SeatKind } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class PositionDetailsSkillsAccessService {
  private readonly currentUserFacade = inject(TellentCurrentUserDataFacade);

  private readonly coreHrSeat = this.currentUserFacade.seatByKind(SeatKind.CoreHR);
  private readonly growSeat = this.currentUserFacade.seatByKind(SeatKind.Grow);

  public readonly accessState = computed(() => {
    if (!this.coreHrSeat()) return 'no_hr';
    if (!this.growSeat()) return 'no_grow';
    return 'ok';
  });
}
